


























































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import MailingsListDetails from "./MailingsListDetails.vue";

import MailingListJson from "../../shared/MailingListJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "MailingsLists",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    MailingsListDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      allMailingLists: [] as MailingListJson[] | null,
      showDetails: false,
      detailsMode: "read",
      selectedMailingListId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: MailingListJson | null, mode: string) {
      if (item != null) {
        this.selectedMailingListId = item.ID;
      } else {
        this.selectedMailingListId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadMailingLists();
    },

    async loadMailingLists() {
      this.allMailingLists = null;
      this.selectedMailingListId = null;

      if (this.restClient != null) {
        try {
          this.allMailingLists = await this.restClient.getMailingLists();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadMailingLists();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    mailingListColumns: function (): TableViewColumnDefinitions<MailingListJson>[] {
      return [
        {
          th: "Name",
          td: (i) => i.name,
        },
        {
          th: "Öffentliche Anmeldung",
          td: (i) => (i.isSignUpPublic ? "Ja" : "Nein"),
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<MailingListJson>[];
    },
  },
});
